
import {
  SEND_RESET_CODE_REQUEST,
  SEND_RESET_CODE_SUCCESS,
  SEND_RESET_CODE_FAILURE,
  VERIFY_RESET_CODE_REQUEST,
  VERIFY_RESET_CODE_SUCCESS,
  VERIFY_RESET_CODE_FAILURE,
  RESET_USER,
  RESET_USER_SUCCESSFUL,
  RESET_USER_FAILED,
  CLEAR_SUCCESS,
} from "./actionTypes";

export const sendResetCodeRequest = (email) => ({
  type: SEND_RESET_CODE_REQUEST,
  payload: { email },
})

export const sendResetCodeSuccess = ( email, message) => ({
  type: SEND_RESET_CODE_SUCCESS,
  payload: { email, message },
})

export const sendResetCodeFailure = (error) => ({
  type: SEND_RESET_CODE_FAILURE,
  payload: error,
})

export const verifyResetCodeRequest = (email, code) => ({
  type: VERIFY_RESET_CODE_REQUEST,
  payload: { email, code },
})

export const verifyResetCodeSuccess = ( email, message) => ({
  type: VERIFY_RESET_CODE_SUCCESS,
  payload: { email, message },
})

export const verifyResetCodeFailure = (error) => ({
  type: VERIFY_RESET_CODE_FAILURE,
  payload: error,
})

export const resetUser = (email, code, newPassword, history) => ({
  type: RESET_USER,
  payload: { email, code, newPassword, history },
})

export const resetUserSuccessful = (user) => ({
  type: RESET_USER_SUCCESSFUL,
  payload: user,
})

export const resetUserFailed = (error) => ({
  type: RESET_USER_FAILED,
  payload: error,
})

export const clearSuccess = () => {
  return {
    type: CLEAR_SUCCESS,
  }
}
